<template>
  <div class="theater-region-list">
    <div v-for="(prefectures, region) in allRegions" class="theater-region">
      <h4-commom :title="region" add-class="ttl_h4--no-border"></h4-commom>
      <div class="theater-prefecture">
        <ul class="theater-prefecture__list">
          <li v-for="prefecture in prefectures" class="theater-prefecture__item">
            <a v-bind:href="'/theater/' + encodeURI(prefecture) + '/' + (productSid ? '?product_sid=' + productSid : '')">{{ prefecture }}</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import TheaterApiClass from '../../../mixin/js/aukana/theater-api';
import H4Commom from '../common/h4'

let TheaterApi = new TheaterApiClass;

export default {
  name: 'all-regions',
  components: {
      H4Commom
  },
  data() {
    return {
      allRegions: {},
      productSid: document.querySelector('meta#productSid').getAttribute('content'),
    }
  },
  mounted() {
    Promise.all([
        this.fetchAllRegions()
      ]).then(results => {
        this.$emit('loadedComponents', this.$options._componentTag)
      });
  },
  methods: {
    async fetchAllRegions() {
      const allRegions = await TheaterApi.getAllRegions(this.productSid);
      const allRegionObj = {};
      for (const region of allRegions) {
        const prefectures = await TheaterApi.getPrefecturesOfRegion(region, this.productSid)
        allRegionObj[region] = prefectures;
      }
      this.allRegions = allRegionObj;
    }
  }
}
</script>